import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { config } from '@app/config';
import Cookies from 'js-cookie';
import gtmTracking from '@app/utils/gtmTracking';
import Style from './SaveAd.module.scss';
import { saveAd, unsaveAd } from './action';

const like = `${config.staticUrl}chotot-icons/next/save-ad.svg`;
const unlike = `${config.staticUrl}chotot-icons/next/save-ad-active.svg`;

const STATE = {
  like: {
    icon: { src: like, alt: 'like', label: 'Lưu tin' },
    action: saveAd,
  },
  unlike: {
    icon: { src: unlike, alt: 'unlike', label: 'Đã lưu' },
    action: unsaveAd,
  },
};

const SaveAd = ({
  size,
  fullView,
  listId,
  category,
  activeAds,
  customClassName,
  authenticated,
  dispatch,
  statusAd,
  // subject,
  eventName,
  adDetail,
  adId,
  accountId,
  index,
}) => {
  const state = activeAds[listId] ? 'unlike' : 'like';
  const { icon, action } = STATE[state];
  const handleOnClick = (e) => {
    e.preventDefault();
    const actionSaveAd = activeAds[listId] ? 'remove_from_save_ad' : 'click_save_ad';
    if (['job_personalize_ads', 'slot_for_sale'].includes(eventName)) {
      const label = eventName === 'slot_for_sale' ? index : adId;

      const rest = {
        page_type: 'job_homepage',
        finger_print: Cookies.get('ctfp') || 'none',
        account_id: accountId,
        ad_id: adId,
        sub_category_id: category,
      };

      if (eventName === 'slot_for_sale') {
        rest.category_id = 13000;
      } else {
        rest.position = index;
      }

      gtmTracking(eventName, `${label}`, 'save_ad', rest);
    } else {
      gtmTracking(eventName, `${adId}`, actionSaveAd);
    }
    if (authenticated) {
      dispatch(action(listId, statusAd));
    } else {
      window.location.href = `${config.accountBaseUrl}?continue=${encodeURIComponent(
        window.location.href
      )}`;
    }
  };

  const getItem = ({ label, alt, src }) =>
    ({
      true: () => (
        <button
          id="btn_save_ad"
          type="button"
          className={Style.btnSavedAdFull}
          onClick={(event) => handleOnClick(event)}
        >
          {label}
          &nbsp;
          <img width={size} src={src} alt={alt} />
        </button>
      ),
      false: () => (
        <button id="btn_save_ad" type="button" className={Style.btnSavedAd} onClick={handleOnClick}>
          <img width={size} src={src} alt={alt} />
        </button>
      ),
    }[fullView]);

  return (
    <div className={`${Style.saveAdWrapper} ${customClassName}`}>
      {!adDetail ? (
        getItem(icon)()
      ) : (
        <button type="button" className={Style.saveAdViewDetail} onClick={handleOnClick}>
          <p style={{ marginRight: '5px' }}>{state !== 'unlike' ? 'Lưu tin' : 'Đã lưu'} </p>
          {getItem(icon)()}
        </button>
      )}
    </div>
  );
};

SaveAd.defaultProps = {
  fullView: false,
  statusAd: null,
  size: 16,
  customClassName: '',
  adDetail: false,
  eventName: '',
};

SaveAd.propTypes = {
  size: PropTypes.number,
  fullView: PropTypes.bool,
  listId: PropTypes.number.isRequired,
  category: PropTypes.number.isRequired,
  activeAds: PropTypes.objectOf(PropTypes.bool).isRequired,
  customClassName: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  authenticated: PropTypes.bool.isRequired,
  statusAd: PropTypes.string,
  // subject: PropTypes.string.isRequired,
  adDetail: PropTypes.bool,
  adId: PropTypes.number.isRequired,
  accountId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  eventName: PropTypes.string,
};

const mapStateToProps = ({ savedAd, auth }) => ({
  activeAds: savedAd.activeAds,
  authenticated: auth.authenticated,
  accountId: auth.accountId || 'none',
});

export default connect(mapStateToProps, null)(memo(SaveAd));
